export default __webpack_public_path__ + "static/media/FavoriteTwo.cc2859bc.svg";